import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { SessionStorageService } from '../../../core/services/storage/session-storage.service';
import { StorageNames } from '../../../core/constants/storage-names.provider';

/**
 * Used to prevent access to the services tab to users with the "accessGlobalSettings" permission
 */
export const servicesGuard: CanActivateFn = (route, state) => {
  const sessionStorage = inject(SessionStorageService);

  const userInfo = sessionStorage.getItem(StorageNames.User);
  // @ts-ignore
  if (userInfo?.accessGlobalSettings) return true;

  return false;
};
